import React from "react";
import { observer } from "mobx-react";
import Grid from "@mui/material/Grid2";

const DivCss = (props) => {
  const { item, inline, css, gridItem } = props;

  const jprop = item.Jprop || {};
  var col = jprop.col || {};

  //const styleProps = getStyle(item.eventProps);
  var className = jprop.className ? jprop.className : "";
  var cssLabel =
    css && css.field && css.field.label ? css.field.label : "inline-label";
  cssLabel = `doc-field ${!inline ? cssLabel : ""} ${className}`;

  return (
    <>
      {gridItem && col.new && <div className="row-break"></div>}
      {gridItem ?
        <Grid
          item
          size={col}
          
        >
      <Grid
        id={props.id}
        children={props.children}
        className={cssLabel}
		// ?? trebuie rescrisa pareta de style 
        //sx={styleProps.field}
      />
      </Grid>
      :
      <div
        id={props.id}
        children={props.children}
        className={cssLabel} 
		// ?? trebuie rescrisa pareta de style 
        //style={styleProps.field}
      />
      }
    </>
  );
};
export default observer(DivCss);
